<template>
  <!--  <div>-->
  <b-form-group label-for="user-name">
<!--    {{ fieldsData.id }}-->
    <!--    {{typeof fieldsData.id}}-->
    <!--            <validation-  provider-->
    <!--                #default="{ errors }"-->
    <!--                :name="fieldsData.name"-->
    <!--                :rules="fieldsData.required == 1 ? 'required' : ''">-->
    <!--    <label  v-html="fieldsData.label[selectlang]"></label>-->
    <!--    {{file1}}-->
    <b-form-file
        v-model="fieldsData.id"
        :state="Boolean(fieldsData.id)"
        class="form-control mt-2"
        drop-placeholder="Drop file here..."
        placeholder=""
        @input="UpdateValue($event)"
    ></b-form-file>
    <!--    <div class="mt-3">Selected file: {{ file1 ? file1.name : '' }}</div>-->
    <!--    {{file2}}-->
    <img :src="file2" v-if="file2" style="width: 100px;height: 100px"/>
    <!--    <v-file-input label="File input" variant="solo-inverted"></v-file-input>-->
  </b-form-group>
  <!--  </div>-->
</template>

<script>

export default {
  components: {

    // ValidationProvider,
  },
  // props: {
  //   fieldsData: {
  //     // type: Object,
  //     // default: () => fieldsData,
  //   },
  // },
  data() {
    return {
      file1: null,
      file2: '',
      rules: [],
      // errors: [],
      DataArray: {},
      errorshow: false,
      // required,
    };
  },
  props: ['fieldsData', 'selectlang'],
  created() {
    if (this.fieldsData.id) {
      // this.file1= this.fieldsData.id;
      this.file1 = {name: this.fieldsData.id};
      this.file2 = this.fieldsData.id;
    }
    // this.checkimage();

  },

  watch: {
    fieldsData: {
      handler(newVal, oldVal) {
        console.log( oldVal);
        this.UpdateValue(newVal.id);

      },
      deep: true,
    },
  },
  methods: {
    triggerAlert() {
      alert("Field is empty!");
    },
    UpdateValue(value) {
      // alert(value);
      this.$emit('input', value)
      if(value){
      this.file2 = URL.createObjectURL(value);
      }else {
        this.file2 ="";
      }
    },
    // checkimage(){
    //   if(this.fieldsData.id ==''){
    //     this.file1 = { name: '' };
    //
    //     this.file2 =  '' ;
    //
    //   }
    //
    // }


  }
}
</script>

<style>
/* Add your styles here */
</style>
